<template>
  <div class="main-container">
    <section v-if="fiaInsightsItems.length" class="fia-insights">
      <div class="section-header">
        <div class="section-header-left">
          <router-link v-if="fiaInsightsRoot"
            :to="{ name: 'fiaIntelligenceDetails', params: { id: fiaInsightsRoot.id, slug: fiaInsightsRoot.slug } }"
            class="title">
            {{ $t("fiaIntelligence") }}
          </router-link>
          <p class="subtitle">{{ $t("fiaIntelligenceSubtitle") }}</p>
        </div>
        <!-- <router-link v-if="fiaInsightsRoot"
          :to="{ name: 'menuDetailsNew', params: { id: fiaInsightsRoot.id, slug: fiaInsightsRoot.slug } }"
          class="see-all-link">
          {{ $t("seeAll") }} →
        </router-link> -->
      </div>

      <div class="insights-grid">
        <app-fia-insights-card v-for="(item, index) in fiaInsightsItems" :key="item.id" :item="item"
          :accent-index="index" />
      </div>
    </section>
  </div>
</template>

<script>
import HighlightedFiaInsightsCard from './HighlightedFiaInsightsCard.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'HighlightedFiaInsights',
  components: {
    appFiaInsightsCard: HighlightedFiaInsightsCard
  },
  computed: {
    ...mapGetters(['fiaInsightsItems', 'fiaInsightsRoot'])
  }
}
</script>

<style scoped>
.main-container {
  padding: 3rem 7%;
  width: 100%;
}

.fia-insights {
  max-width: 1440px;
  margin: 0 auto;
  /* background: #f0f4f9; */
  border-bottom: 1px solid #dde3ed;
}

/* ── Header row ── */
.section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.section-header-left {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
}

.title {
  color: var(--main-color);
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
}

.title:hover {
  text-decoration: underline;
}
.subtitle {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.see-all-link {
  font-size: 13px;
  font-weight: 500;
  color: var(--main-color);
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: opacity 0.2s ease;
}

.see-all-link:hover {
  opacity: 0.7;
  text-decoration: none;
}

/* ── Cards grid ── */
.insights-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

/* Cards stretch to equal height — footer naturally pins to bottom */
.insights-grid>* {
  display: flex;
  flex-direction: column;
}

@media (max-width: 1200px) {
  .insights-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .insights-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .section-header-left {
    flex-direction: column;
    gap: 4px;
  }

  .insights-grid {
    grid-template-columns: 1fr;
  }
}
</style>